// extracted by mini-css-extract-plugin
export default {"question":"question-BnXmi","img":"img-tAKUV","content":"content-__fgx","text":"text-BczR6"};